import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, hashHistory, browserHistory, Redirect } from 'react-router';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import configureStore from './stores';

const store = configureStore();

import App          from './containers/App';
import Top          from './containers/Top';
import About        from './containers/About';
import WorksDetail  from './containers/WorksDetail';
import Member       from './containers/Member';
import MemberDetail from './containers/MemberDetail';
import Topics       from './containers/Topics';
import TopicsDetail from './containers/TopicsDetail';

ReactDOM.render(
  <AppContainer>
    <Provider store={store}>
      <Router history={browserHistory}>
        <Route path='/' component={App}>
          <IndexRoute component={Top} />
          <Route name='top' path='/' component={Top} />
          <Route name='about'  type='about' path='/about/' component={About} />
          <Route name='works'  type='detail' path='/works/:slug' component={WorksDetail} />
          <Route name='member' type='member' path='/member/' component={Member} />
          <Route name='member' type='detail' path='/member/:slug' component={MemberDetail} />
          <Route name='topics' type='topics' path='/topics/' component={Topics} />
          <Route name='topics' type='detail' path='/topics/:slug' component={TopicsDetail} />
          <Redirect from="/works/" to="/" />
        </Route>
      </Router>
    </Provider>
  </AppContainer>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./client.js